import { postService } from "../axios/axios";
import { COMPOSITE_SEARCH_SERVICE } from "../constants/baseURLs";
import { CS_IS_ACTIVE_FILTER, CS_SCOPES } from "../constants/constants";
import { formCompositeSearchQuery } from "./csQueryUtils";
/**
    *Function to call search people Service
    *@param {string} query
    */
    export const getPeopleIdFromName = (firstName, lastName) => {
        const userTypeQuery = [
            {
                "key": "firstName",
                "value": firstName,
                "operation": "match"
            },
            {
                "key": "lastName",
                "value": lastName,
                "operation": "match"
            }
        ];
        const defaultQuery = {
            "filters": [CS_IS_ACTIVE_FILTER, ...userTypeQuery],
            "operation": "AND",
            "properties": null
        }
        const query = formCompositeSearchQuery([CS_SCOPES.PEOPLE], {}, {}, {}, {}, {}, defaultQuery);
        return new Promise((resolve, reject) => {
            postService(
                COMPOSITE_SEARCH_SERVICE,
                `/composite-search/v1?returnCsv=false`,
                query
            )
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }